import React from 'react';
import { useNavigate } from 'react-router-dom';
import logo from './assets/Logo.png';
import "./AddCar.css";

function AddCar() {
  const navigate = useNavigate();

  return (
    <>
      <header className="header-addcar">
        <img src={logo} alt="Logo" className="header-logo" />
      </header>

      <div className="main-container">
        <div className="CarSelection">
          <h1>🚗 Add a New Car</h1>
          <hr />
          <p style={{ textAlign: "center" }}>
            How would you like to add your car?
          </p>

          <div className="button-container" style={{ width: "100%", maxWidth: "100%" }}>
            <button
              className="confirm-button"
              onClick={() => navigate("/add-car-manual")}
            >
              📝 Manually Enter Car Info
            </button>

            <button
              className="confirm-button"
              onClick={() => navigate("/add-car-vin")}
            >
              🔍 Use VIN to Auto Fill
            </button>
          </div>

          <button
            className="back-button"
            onClick={() => navigate("/customer-dashboard")}
          >
            ⬅️ Back to Dashboard
          </button>
        </div>
      </div>
    </>
  );
}

export default AddCar;